module.exports = __webpack_public_path__ + "static/media/avatar-H_J.cfec0777.png";